<template>
    <template v-if="noSidebar">
        <div id="mainContent" class="flex flex-col justify-between items-center bg-main-bg px-base-2 py-5 min-h-screen w-full dark:bg-dark-body dark:text-white h-screen">
            <div>&nbsp;</div>
            <div class="max-w-md w-full">
                <div class="text-center mb-10">
                    <Logo />
                </div>
                <router-view :key="$route.path" />
            </div>
            <FooterSite class="text-center" />
        </div>
    </template>
    <div v-else class="flex items-stretch w-full pt-16 pb-16 lg:py-0">
        <HeaderMobile />
        <Sidebar />
        <main id="main" role="main" class="main-content w-full lg:w-main-content">
            <HeaderSite v-if="!noHeader" />
            <div v-if="error" class="max-w-container w-full mx-auto p-0 md:px-base-2 md:py-base-2">
                <NotFound />
            </div>
            <template v-else>
                <Container v-if="layouts.header.center.length > 0" class="px-0 md:px-base-2 py-0">
                    <div v-for="(dataHeader, index) in layouts.header.center" :key="index">
                        <component :is="loadComponentData(dataHeader)" :data="dataHeader"></component>
                    </div>
                </Container>
                <Container class="p-0 md:px-base-2 md:py-base-2">
                    <router-view :key="$route.path" />
                </Container>
                <Container v-if="layouts.footer.center.length > 0" class="px-0 pt-0 pb-0 md:px-base-2 md:pb-6">
                    <div v-for="(dataFooter, index) in layouts.footer.center" :key="index">
                        <component :is="loadComponentData(dataFooter)" :data="dataFooter"></component>
                    </div>
                </Container>
            </template>
        </main>
        <FooterMobile />
    </div>
    <StockTickersBar class="hidden lg:block" />
    <SwitchPagePopover/>
    <ChatBubble />
</template>

<script>
import { mapState } from 'pinia'
import { useAppStore } from '@/store/app'
import { defineAsyncComponent } from "vue";
import FooterSite from '@/components/layout/FooterSite.vue';
import Sidebar from '@/components/layout/Sidebar.vue'
import HeaderSite from '@/components/layout/HeaderSite.vue'
import FooterMobile from '@/components/layout/FooterMobile.vue';
import HeaderMobile from '@/components/layout/HeaderMobile.vue';
import Container from '@/components/article/Container.vue';
import BaseButton from '@/components/inputs/BaseButton.vue'
import Logo from '@/components/utilities/Logo.vue';
import SwitchPagePopover from '@/components/popover/SwitchPagePopover.vue';
import ChatBubble from '@/components/layout/ChatBubble.vue';
import NotFound from '@/components/utilities/NotFound.vue';
import StockTickersBar from '@/components/tickers/StockTickersBar.vue';

export default {
    components: {
        FooterSite,
        Sidebar,
		HeaderSite,
		StockTickersBar,
		FooterMobile,
        HeaderMobile,
        Container,
        BaseButton,
        Logo,
		SwitchPagePopover,
		ChatBubble,
        NotFound
    },
    data() {
		return {
			error: false
		};
	},
    computed: {
        ...mapState(useAppStore, ['layouts', 'errorLayout']),
        noSidebar() {
            return ['first_login', 'email_confirm', 'phone_confirm'].includes(this.$route.name)
        },
        noHeader() {
            return ['vibb'].includes(this.$route.name)
        }
    },
    watch: {
        errorLayout(error) {
			this.error = error
		},
    },
    methods: {
        loadComponentData(data) {
            if (data.type == 'component') {
                return defineAsyncComponent(() => import(`./components/widgets/${data.package}/${data.component}.vue`))
            } else {
                const routeDirMap = {
                    home: 'home',
                    home_page: 'home',
                    profile: 'profile',
                    post: 'post',
                    watch: 'watch',
                    media: 'media',
                    bookmarks: 'bookmarks',
                    documents: 'documents',
                    discovery: 'discovery',
                    sp_detail: 'sp_detail'
                }
                const dir = routeDirMap[this.$route.name] || this.$route.name
                const pages = import.meta.glob('./pages/**/**/*.vue')
                const key = `./pages/${dir}/${data.component}.vue`
                if (pages[key]) {
                    return defineAsyncComponent(pages[key])
                }
                return defineAsyncComponent(() => import(`./pages/${dir}/${data.component}.vue`))
            }
        }
    }
}
</script>
